export default __webpack_public_path__ + "static/media/app-logo.4b6541a3.svg";